<!-- Static image for export mode (non-custom charts) -->
@if (renderAsImage && chartImageDataUrl) {
<div class="exportView w-full" [style.minHeight.rem]="height">
  <img [src]="chartImageDataUrl" class="block w-full object-contain object-top" [style.minHeight.rem]="height"
    alt="Chart" />
</div>
}

<div [ngClass]="{'exportView ':export, 'opacity-0 h-0 overflow-hidden':rowView || !chartAvailable || renderAsImage}">
  <div [ngClass]="{'exportView':export}" class="ltr-chart flex flex-col items-center" [style.minWidth.rem]="width"
    [style.minHeight.rem]="height" #chartSelector></div>
</div>
<div [hidden]="!rowView || !chartAvailable">
  <div class="block -ml-10 -mr-10 px-10">

    @if(_chart?.legend?.data?.length && customChart?.length && customChart[0]?.length &&
    customChart[0][0]?.values?.length){
    <div class="inline-flex">
      @for (legend of customChart[0][0].values; track legend) {
      <div class="flex flex-row gap-1.5 items-center px-2.5">
        <i [style.color]="legend.itemStyle?.color" class="fa-solid fa-square text-xl"></i>
        <h5 class="text-xs text-zen">{{legend.series}}</h5>
      </div>
      }
    </div>
    }

    @for (pageData of customChart; track pageData; let pageIndex = $index) {
    <span class="block" [ngClass]="{ 'pt-20 break-before': pageIndex && export }"></span>
    <div [class]="export? chart?.classes?.innerContainer:'px-5'">
      @if((pageData && pageData.length && pageData[0]?.values?.length == 1) && (export || (!export && !pageIndex)) ){
      <div class="flex flex-row items-stretch w-full gap-2">
        <div class="w-1/3 h-0"></div>
        <div class="flex flex-row justify-end w-2/3 gap-4">
          <div class="w-10/12 h-0"></div>
          <div class="flex flex-row items-center justify-end gap-1 w-2/12">
            @if(hasCountValue){
            <h5 class="text-zen leading-5 text-xs w-1/2 text-center capitalize">{{'txtValue' |
              translate:language:'Shared'}}</h5>
            }
            <h5 class="text-zen leading-5 text-xs w-1/2 text-center">%</h5>
          </div>
        </div>
      </div>
      }

      @for (row of pageData; track row; let rowIndex = $index) {
      <div class="block w-full py-2" [class.cursor-pointer]="chart?.onClick"
        (click)="onCustomChartRowClick(row, rowIndex)">
        <ng-container
          *ngTemplateOutlet="rowTemplate; context: { $implicit: row, index: rowIndex, pageIndex: pageIndex }"></ng-container>
        <!-- Fallback display if no template provided -->
        @if (!rowTemplate) {
        <div class="flex flex-row gap-2 w-full">
          <h5 class="text-sm text-zen w-1/3">{{ row.category }}</h5>
          <!-- MULTI-SERIES DISPLAY -->
          <div class="flex flex-col gap-2 w-2/3">
            @if (row.values && row.values.length > 1) {
            <div class="flex flex-row items-center w-full bg-zen bg-opacity-10 h-5 rounded-sm overflow-hidden"
              (click)="logData(row.values)">
              @for (series of row.values; track series) {
              <div class="flex flex-row items-stretch gap-4 h-5"
                [style]="{ width: (series.value ?? 0) + '%',backgroundColor: series.data?.itemStyle?.color || series.itemStyle?.color|| '#0082C6'}">
                <div class="flex flex-row w-full  justify-center items-center">
                  <span class="text-white leading-5 text-xs ">{{series.value > 0?( series.value | number :
                    '1.1-1') + '%':''}}</span>
                </div>
              </div>
              }

            </div>
            }
            @else if (row.values && row.values.length === 1) {
            @let series = row.values[0];
            <div class="flex flex-row items-stretch gap-4 h-5 w-full">
              <div
                class="flex flex-row items-stretch w-10/12 bg-zen bg-opacity-10 h-5 rounded-sm overflow-hidden gap-px">
                <div class="relative"
                  [style]="{ width: (series.value ?? 0) + '%',backgroundColor: series.data?.itemStyle?.color || '#0082C6'}">
                </div>
              </div>
              <div class="flex flex-row items-center justify-end gap-1 w-2/12">
                @if(hasCountValue){
                <h5 class="text-zen leading-5 text-xs w-1/2 text-center">{{series.value1??0}}</h5>
                }
                <h5 class="text-zen leading-5 text-xs w-1/2 text-center">{{series.value?( series.value | number :
                  '1.1-1'):''}}%</h5>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
</div>

@if (!chartAvailable) {
<ng-content select="[empty]"></ng-content>
}